/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nftInfo.vue?vue&type=template&id=21ac9900&scoped=true"
import script from "./nftInfo.vue?vue&type=script&lang=js"
export * from "./nftInfo.vue?vue&type=script&lang=js"
import style0 from "./nftInfo.vue?vue&type=style&index=0&id=21ac9900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac9900",
  null
  
)

export default component.exports